import './Meta.styles.css';

const MetaItem = ({ icon, content }) => {
    return (
        <div className="ui-meta-item">
            {
                icon ? (
                    <div className="ui-meta-item-icon">
                        { icon }
                    </div>
                ) : null
            }

            <div className="ui-meta-item-main">
                { content }
            </div>
        </div>
    );
}

const Meta = ({ items, className = '' }) => {
    return (
        <div className={'ui-meta ' + className}>
            {
                items.map(({ content, icon }, index) => <MetaItem key={index} content={content} icon={icon} />)
            }
        </div>
    );
}

export default Meta;
